import React from 'react';

interface OpenActionProps {
  onClick?: () => void;
  children?: React.ReactNode;
  className?: string;
}

/** Primary list action — the only action visible on mobile stack tables. */
const OpenAction: React.FC<OpenActionProps> = ({
  onClick,
  children = 'Abrir',
  className,
}) => (
  <button
    type="button"
    className={`link-btn action-open${className ? ` ${className}` : ''}`}
    onClick={onClick}
  >
    {children}
  </button>
);

export default OpenAction;
